import { BaseApiAuth } from '@/api/BaseApiAuth'
import { PublicationStorage, PublicationStorageCollection } from '@/typings/api/Publication'
import { AxiosRequestConfig } from 'axios'

export class StorageApi extends BaseApiAuth<
    PublicationStorage,
    PublicationStorageCollection> {
    protected readonly endpoint = '/publications/storages';

    public updateFilesTimes(file: File, params: Record<string, unknown>, config?: AxiosRequestConfig) {
      const path = ':storage_id/update-files-times'
      const [url] = this.getUrl(path, params)
      const data = new FormData()
      data.append('file', file)
      return this.request('POST', url, { data, ...config })
    }
}
